<template>
    <li :class="['footer-link', {'icon': icon !== ''}, icon]" v-if="isLabel">
        <span v-if="isLabel && !isLink" v-html="label"></span>
        <a v-if="isLink && isLabel" class="footer-link__url" :href="computedUrl" target="_blank" rel="noopener noreferrer" v-html="label"></a>
    </li>
</template>

<script>
    export default {
        name: 'footer-link',
        props: {
            label: {
                type: String,
                default: '##blank##'
            },
            url: {
                type: String,
                default: '##blank##'
            },
            icon: {
                type: String,
                default: ''
            }
        },
        computed: {
            isLink () { return this.label && this.url.trim() !== '##blank##' },
            isLabel () { return this.label && this.label.trim() !== '##blank##' },
            computedUrl () {
                if (this.icon === 'phone') {
                    return `tel:${this.url}`
                }
                if (this.icon === 'email') {
                    return `mailto:${this.url}`
                }
                return this.url
            }
        }
    }
</script>

<style lang="scss" scoped>
    .footer-link {
        text-decoration: none;
        list-style: none;
        font-size: 1.6rem;
        color: $white;
        position: relative;
        display: flex;
        align-items: center;

        &:hover {
            text-decoration: underline;
            text-decoration-color: $white;
        }

        &.icon {
            margin: 0 0 0 35px;

            &:before {
                font-family: 'icomoon';
                font-size: 2rem;
                position: absolute;
                margin: 0 0 0 -35px;
            }
        }

        &.chat:before {
            content: '\e94a';
        }

        &.contact:before {
            content: '\e909';
        }

        &.email:before {
            content: '\e900';
        }

        &.phone {
            text-decoration: none;

            &:before {
                transform: scale(-1, 1);
                content: '\e94b';
            }
        }

        &.faq:before {
            content: '\e966';
        }

        &__url {
            color: $white;
        }
    }
</style>
